class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

/*
 * Shopify Common JS
 *
 */
function debounce(fn, wait) {
	let t;
	return (...args) => {
		clearTimeout(t);
		t = setTimeout(() => fn.apply(this, args), wait);
	};
}

function fetchConfig(type = 'json') {
	return {
		method: 'POST',
		headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
	};
}

if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  console.log(selector, value)
  for (let i = 0, count = selector.options.length; i < count; i++) {
    let option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  let method = options['method'] || 'post';
  let params = options['parameters'] || {};

  let form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(let key in params) {
    let hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    let value = this.countryEl.getAttribute('data-default');
		console.log("TCL: value", value)
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    let value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    let opt       = this.countryEl.options[this.countryEl.selectedIndex];
    let raw       = opt.getAttribute('data-provinces');
    let provinces = JSON.parse(raw);



    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (let i = 0; i < provinces.length; i++) {
        opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (let i = 0; i < values.length; i++) {
      let opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('[type="button"]');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);


class VariantSelects extends HTMLElement {
  constructor() {
    super();
    if (this.dataset.variation == 'look') {
      this.arrayLookIds = [];
      this.getStorageLookIds()
      this.setButtonStyle()
      this.injectTotalPrice()
      this.setAddToCartState()
    }

    this.disableInexistantVariants()
   
    this.addEventListener('change', (e) => this.onVariantChange(e));
  }

  onVariantChange(e) {
    this.updateOptions(e);
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      if (this.dataset.variation == 'look') {
        this.getStorageLookIds()
        this.setChosenLooks()
        this.renderProductInfo();
        this.injectTotalPrice()
      } else {
        this.updateURL();
        this.updateVariantInput();
        this.renderProductInfo();

       

      }
    }
  }
  disableInexistantVariants() {
    const dataVariants = this.querySelector('[data-variants]')
    const allVariants = JSON.parse(dataVariants.textContent) // tous les variants
    const selectedColor = this.querySelector('[data-facets-color]:checked').value  // couleur sélectionnéee

    // variant disponibles pour cette couleur
    let availableVariants = allVariants.filter(el => el.option1 === selectedColor)
    let variantsAvailableMapped = new Map(availableVariants.map((el) => [el.option2, el]))
  
    // Si un élément taille n'est pas dans le tableau des variants diponibles, on le désactive
    this.querySelectorAll('[data-facets-size]').forEach((size) => { 
      if (!variantsAvailableMapped.get(size.value)) {
        this.querySelector(`label[for='${size.id}']`).classList.add('t-button--disabled-with-stroke')
      }
    })
  }
  getStorageLookIds() {
    let arrayIdsFromStorage = window.localStorage.getItem('lookIds');
    if (arrayIdsFromStorage) {
      this.arrayLookIds = JSON.parse(arrayIdsFromStorage)
    }
  }
  setAddToCartState() {
    if (this.arrayLookIds.length > 0) {
      document.querySelector('[data-look-add]').removeAttribute('disabled');
    } else {
      document.querySelector('[data-look-add]').setAttribute('disabled', true);
    }
  }
  setButtonStyle() {
    this.arrayLookIds.forEach(item => {
      let domEl = this.querySelector(`[data-variant-id='${item.id}']`)
      if (!domEl) {
        return
      }
      domEl.classList.add('is-active')
    })
  }
  setChosenLooks() {
    const newObject = this.getNewObject()

    let sameVariantCheckedIndex = this.arrayLookIds.findIndex(item => item.id === newObject.id);
    let sameProductParentIndex = this.arrayLookIds.findIndex(item => item.productId === newObject.productId);
    let isNoCompleted = this.currentVariant.no_completed

    // si variant incomplet, on le supprime du tableau
    if (isNoCompleted) {
      if (sameProductParentIndex !== -1) {
        this.deleteFromArrayLooks(sameProductParentIndex);
      }
    } else if (sameVariantCheckedIndex !== -1) {  // si c'est le même produit variant qui est recoché, on le supprime du tableau
      this.deleteFromArrayLooks(sameVariantCheckedIndex);
    } else if (sameProductParentIndex !== -1) {  // si c'est un variant d'un produit similaire on le remplace
      this.arrayLookIds[sameProductParentIndex] = newObject;
    } else {
      // si non on ajoute le nouvel objet
      this.arrayLookIds.push(newObject);
    }
    this.setAddToCartState()
    // et on push le nouveau tableau
    window.localStorage.setItem('lookIds', JSON.stringify(this.arrayLookIds));
  }
  deleteFromArrayLooks(index) {
    this.arrayLookIds.splice(index, 1);
  }
  injectTotalPrice() {
    const totalPrice = (this.arrayLookIds.reduce((sum, item) => sum + item.price, 0) / 100).toFixed(2);
    if (document.querySelector('[data-total]')) {
      document.querySelector('[data-total]').innerHTML = totalPrice
    }
  }
  getNewObject() {
    return {
      url: this.dataset.url,
      productId: this.dataset.productId,
      id: this.currentVariant.id,
      price: this.currentVariant.price,
    }
  }
  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });

    if (this.currentVariant) {
      this.currentVariant.completed = false
    }
    // si on n'a pas deux options qui correspondent et qu'on est sur la variation look, on prend le premier élément en current
    if (!this.currentVariant && this.dataset.variation == 'look') {
      this.currentVariant = this.getVariantData().find(variant => variant.options[0] == this.options[0])
      this.currentVariant.no_completed = true
    }


  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    let fetchUrl = new URL(window.location);
    fetchUrl.pathname = `${this.dataset.url}`
    fetchUrl.searchParams.append('variant',  this.currentVariant.id)
    if (this.dataset.variation == 'look') {
      fetchUrl.searchParams.append('section_id', 'product-select-variant-look');
    } else {
      fetchUrl.searchParams.append('section_id',  `${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
    }

    fetch(fetchUrl)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(window.variantStrings.soldOut, !this.currentVariant.available);

        // rerender les variants car option2 liée à option1 dans le cas de double variant
        let variantsRerender = html.querySelector(`[data-variants-rerender]`)
        this.closest(`[data-variants-rerender]`).innerHTML = variantsRerender.innerHTML

        const mediasRerender = html.querySelector(`[data-product-media]`)
        document.querySelector(`[data-product-media]`).innerHTML = mediasRerender.innerHTML
      });
  }

  toggleAddButton(text, disable = true, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    if (button) {
      const addButton = button.querySelector('[name="add"]');
      const addButtonText = button.querySelector('[name="add"] > span');
      if (!addButton) return;
      addButtonText.textContent = window.variantStrings.unavailable;
    }
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions(e) {
    const dataVariants = this.querySelector('[data-variants]')
    let allVariants = JSON.parse(dataVariants.textContent)
    let selectedColor = this.querySelector('[data-facets-color]:checked').value

    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      let arrayInputs = Array.from(fieldset.querySelectorAll('input'))
      return arrayInputs.find((radio) => radio.checked)?.value
    });

    // si le variant n'existe pas, on prend le premier variant qui correspond à la couleur
    let isVariantExist = allVariants.find(el => JSON.stringify(el.options) === JSON.stringify(this.options));

    if (!isVariantExist) {
      this.options = allVariants.find(el => el.option1 === selectedColor)?.options
    }
  }
}

customElements.define('variant-radios', VariantRadios);
